import OpenCallList from '../components/OpenCallList';
import PageLayout from '../components/pageLayout';

function OpenCallListPage() {
    return (
        <PageLayout children={<OpenCallList />} />
    );
}

export default OpenCallListPage;
